import React from 'react';
import {
    PushpinOutlined,
} from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
import styles from './index.module.scss';

const ADMIN_FREE_CANVAS_BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/freeCanvas';
const EDIT_ICON = `${ADMIN_FREE_CANVAS_BASE_URL}/edit.svg`;
const COPY_ICON = `${ADMIN_FREE_CANVAS_BASE_URL}/copy.svg`;
const DELETE_ICON = `${ADMIN_FREE_CANVAS_BASE_URL}/delete.svg`;

const ProjectContextMenu = ({
    visible,
    x,
    y,
    pinned = false,
    showPin = true,
    showRename = true,
    showDuplicate = true,
    onPin,
    onDuplicate,
    onRename,
    onDownload,
    onDelete,
}) => {
    if (!visible) return null;

    return (
        <div
            className={styles.menu}
            style={{ left: x, top: y }}
            data-free-canvas-sidebar-menu="true"
        >
            {showPin ? (
                <button type="button" className={styles.menuItem} onClick={onPin}>
                    <PushpinOutlined className={styles.menuIcon} />
                    {pinned ? '取消置顶' : '置顶'}
                </button>
            ) : null}
            {showRename ? (
                <button type="button" className={styles.menuItem} onClick={onRename}>
                    <img src={EDIT_ICON} alt="" className={styles.menuIconImage} draggable={false} />
                    重命名
                </button>
            ) : null}
            {showDuplicate ? (
                <button type="button" className={styles.menuItem} onClick={onDuplicate}>
                    <img src={COPY_ICON} alt="" className={styles.menuIconImage} draggable={false} />
                    创建副本
                </button>
            ) : null}
            {onDownload ? (
                <button type="button" className={styles.menuItem} onClick={onDownload}>
                    <Iconfont type="icon-DownloadOutlined" className={styles.menuIcon} />
                    下载
                </button>
            ) : null}
            <button type="button" className={styles.menuItem} onClick={onDelete}>
                <img src={DELETE_ICON} alt="" className={styles.menuIconImage} draggable={false} />
                删除
            </button>
        </div>
    );
};

export default ProjectContextMenu;
